import gql from 'graphql-tag';
// Toaster
import { toastr } from 'react-redux-toastr';

import {
  MANANGE_LISTING_PUBLISH_STATUS_START,
  MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
  MANANGE_LISTING_PUBLISH_STATUS_ERROR,
} from '../../constants';

// For Redirect
import history from '../../core/history';

// To Refresh the Manage Listing Status
const ManageListingQuery = gql`
  query ManageListings {
    ManageListings {
      listings {
        id
        title
        city
        updatedAt
        coverPhoto
        isPublished
        isReady
        listPhotos {
          id
          name
        }
      }
    }
  }
`;

// To Refresh Listing Steps Query
const ListingStepsQuery = gql`
  query($listId: String!) {
    showListingSteps(listId: $listId) {
      id
      listId
      listing {
        id
        isReady
        isPublished
      }
    }
  }
`;

export function ManagePublishStatus(listId, action) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: MANANGE_LISTING_PUBLISH_STATUS_START, listId, action });

    let mutation = gql`
      mutation ManagePublish($listId: Int!, $action: String!) {
        managePublish(listId: $listId, action: $action) {
          status
        }
      }
    `;

    try {
      let type = 'Publish Listing';
      if (action === 'unPublish') {
        type = 'UnPublish Listing';
      }

      const { data } = await client.mutate({
        mutation,
        variables: {
          listId,
          action,
        },
        // refetchQueries: [{ query: ManageListingQuery }]
      });

      if (data.managePublish.status === '200') {
        // Reload Existing Steps Page
        const { data } = await client.query({
          query: ListingStepsQuery,
          variables: { listId },
          fetchPolicy: 'network-only',
        });
        toastr.success(type, type + ' is success!');
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_SUCCESS,
          payload: {
            listingSteps: data.showListingSteps,
          },
        });
        if (type === 'Publish Listing') {
          history.push('/add-listing/' + listId + '/success?editing=true');
        }
      } else {
        toastr.error(type, type + ' is failed!');
        dispatch({
          type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
          payload: {
            status: data.managePublish.status,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: MANANGE_LISTING_PUBLISH_STATUS_ERROR,
        payload: {
          error,
        },
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/Listing/ManagePublishStatus.js